{
    "deckActionCardDraw": {
        "cards": [
            {
                "name": "Starter_Mining"
            },
            {
                "name": "Starter_Fishing"
            },
            {
                "name": "Starter_ZenithOrders"
            },
            {
                "name": "Starter_Chopping"
            }
        ]
    },
    "deckActionCardDiscard": {
        "cards": []
    },
    "deckActionDrawLeft": {
        "cards": [
            {
                "name": "Season3Action_Kingfisher"
            },
            {
                "name": "Season3Action_Completist"
            },
            {
                "name": "Season3Action_MasterFarmer"
            },
            {
                "name": "Season2Action_ProjectDabbler"
            },
            {
                "name": "Season2Action_Excavator"
            },
            {
                "name": "Season2Action_CovernGrower"
            },
            {
                "name": "Season2Action_ExpertFisher"
            },
            {
                "name": "Season1Action_AxeMiner"
            },
            {
                "name": "Season1Action_NoviceFisher"
            },
            {
                "name": "Season1Action_NoviceForager"
            },
            {
                "name": "Season1Action_FarmClearer"
            }
        ]
    },
    "deckActionDrawRight": {
        "cards": [
            {
                "name": "Season3Action_LakeFisher"
            },
            {
                "name": "Season3Action_MarketDelver"
            },
            {
                "name": "Season3Action_CompleteBuilder"
            },
            {
                "name": "Season2Action_LumberjackFisher"
            },
            {
                "name": "Season2Action_LureMaster"
            },
            {
                "name": "Season2Action_WoodCleaner"
            },
            {
                "name": "Season2Action_FarmForester"
            },
            {
                "name": "Season1Action_RiverDredger"
            },
            {
                "name": "Season1Action_NatureCollector"
            },
            {
                "name": "Season1Action_EnergyEnthusiast"
            },
            {
                "name": "Season1Action_Grower"
            }
        ]
    },
    "deckActionCardActive": {
        "cards": [
            {
                "name": "Starter_Mining_2"
            },
            {
                "name": "Starter_Tending_2"
            },
            {
                "name": "Starter_Tending"
            },
            {
                "name": "Starter_Fishing_2"
            },
            {
                "name": "Starter_Chopping_2"
            }
        ]
    },
    "objectiveOne": {
        "name": "Objective_S1_BigGuy"
    },
    "objectiveTwo": {
        "name": "Objective_S2_Cruncher"
    },
    "objectiveThree": {
        "name": "Objective_S3_Lefty"
    },
    "randomSeed": {
        "seed": 17
    }
}